import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse, HttpResponse, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { ViewConstants } from '../../../app/constants';
import { finalize,catchError } from "rxjs/operators";
import { LoaderService } from '../services/loader.service';
import { SharedDataService } from './../services/shared-data.service';
import { SubSink } from 'subsink';
import { Store } from '@ngrx/store';
import { IAppCoreState } from 'src/app/core/state'; 
import { getUserInfo } from '../state/selectors';
import { EnvironmentConfiguration } from 'src/app/environment/services/environment.configuration';
import { SharedFunctionService } from '../services/shared-func.service';
/** Pass untouched request through to the next request handler. */
@Injectable()
export class AddHeaderInterceptor implements HttpInterceptor {
  public _subs = new SubSink();
  private requestCount = 0;
  constructor(
    public loaderService: LoaderService, 
    private readonly router: Router, 
    private readonly sharedService: SharedDataService, 
    private readonly sharedFunctionService : SharedFunctionService,
    private readonly _store: Store<IAppCoreState>, 
    private readonly environment: EnvironmentConfiguration) { }

  intercept(req: HttpRequest<any>, next: HttpHandler):
    Observable<HttpEvent<any>> {
    if (!(req.urlWithParams.indexOf("/payments") !== -1 && this.router.url.indexOf(ViewConstants.CUSTOMER_VIEW) !== -1)) {
      this.requestCount++;
    }

    
    const fullUrl = req.urlWithParams;// Get the full URL from the request object
    const url = new URL(fullUrl); // Parse the URL to get its components
    const hostname = url.hostname;// Access the hostname property
    // Check if the hostname is exactly the trusted host
    if (hostname === 'dg.toyota.com'  || hostname.endsWith(".dg.toyota.com")) {
      req = this.addIdToken(req);
     }
    //customer view update url.
    const updateWorksheetUrl = this.router.url.indexOf(ViewConstants.CUSTOMER_VIEW) !== -1 && req.urlWithParams.indexOf("/worksheet") !== -1 && req.urlWithParams.indexOf("/worksheet/view") == -1;
    if (req.urlWithParams.indexOf(ViewConstants.CURRENT_SERVICE_URL) === -1 && req.urlWithParams.indexOf("/comments/") === -1 && req.urlWithParams.indexOf("/price") === -1 && !(req.urlWithParams.indexOf("/payments") === -1 && req.urlWithParams.indexOf("retail-deals/dealers/") === -1 && req.urlWithParams.indexOf("deals/dealers/") === -1 && this.router.url.indexOf(ViewConstants.CUSTOMER_VIEW) !== -1) && !updateWorksheetUrl) {
      if (this.sharedService.relationshipTypeCode === 'LEXUS' && this.router.url.indexOf(ViewConstants.CUSTOMER_VIEW) !== -1) {
        this.sharedService.showLexusLoader = true;
      } else {
        this.sharedService.showLexusLoader = false;
      }
    const isUpload = req.urlWithParams.includes('/upload');
    const isCustomersAndWriteup = req.urlWithParams.includes('/customers') && this.router.url.includes('/writeup-detail');
    if (!isUpload && !isCustomersAndWriteup) {
      this.loaderService.show();
    }
    }
    //
    // Clone the request
    //
    let clonedReq: HttpRequest<any> = req.clone();

    //
    // If RTI, no need for X-B3-*
    //
    if (clonedReq.url.indexOf(ViewConstants.RTI) > -1) {
      clonedReq = clonedReq.clone({
        headers: clonedReq.headers.delete('X-B3-TraceId')
          .delete('X-B3-SpanId')
      });
    }

    // 
    // Authentication header
    //
    if (this.Should_Add_Authentication_Token_WithBearer(clonedReq.url)) {
      let token: string;
      if (clonedReq.url.indexOf("user/userInfo") !== -1) {
        token = ViewConstants.BEARER + sessionStorage.getItem(ViewConstants.ACCESS_TOKEN_HTTP_CLIENT);
        clonedReq = clonedReq.clone({ headers: clonedReq.headers.set(ViewConstants.AUTHORIZATION_LOWER_CASE, token) });
      } else {
        this._subs.sink = this._store.select(getUserInfo).subscribe(userInfo => {
          if (userInfo?.hasOwnProperty('isIdToken')) {
            if (userInfo.isIdToken.toLowerCase() == 'true'.toLowerCase()) {
              token = ViewConstants.BEARER + sessionStorage.getItem(ViewConstants.ID_TOKEN_HTTP_CLIENT);
            } else if (userInfo.isIdToken.toLowerCase() == 'false'.toLowerCase()) {
              token = ViewConstants.BEARER + sessionStorage.getItem(ViewConstants.ACCESS_TOKEN_HTTP_CLIENT);
            }
          } else {
            token = ViewConstants.BEARER + sessionStorage.getItem(ViewConstants.ACCESS_TOKEN_HTTP_CLIENT);
          }
          clonedReq = clonedReq.clone({ headers: clonedReq.headers.set(ViewConstants.AUTHORIZATION_LOWER_CASE, token) });

          if (userInfo?.hasOwnProperty('profile')) {
            // Condition to Invoke the addProfile method
            if (clonedReq.url.indexOf(this.environment.MST_BASE_SERVICE_URL) > -1) {
              clonedReq = this.addProfile(clonedReq, userInfo.profile);
            }
          }

          if (userInfo?.hasOwnProperty('dealer_profile')) {
            if (clonedReq.url.indexOf(this.environment.BASE_SERVICE_URL) > -1) {
              clonedReq = this.addDealerProfile(clonedReq, userInfo.dealer_profile);
            }
          }

        });
      }
    }


    if (clonedReq.url.indexOf(ViewConstants.TRADE_SIGNAL_ROUTE) > -1) {
      this._subs.sink = this._store.select(getUserInfo).subscribe(userInfo => {
        if (userInfo?.hasOwnProperty('signal_api_key')) {
         clonedReq = this.addSignalApiKey(clonedReq,userInfo.signal_api_key)
        }})
    }

    if (clonedReq.url.indexOf(ViewConstants.PRE_SOLD_ROUTE) > -1) {
      this._subs.sink = this._store.select(getUserInfo).subscribe(userInfo => {
        if (userInfo?.hasOwnProperty('dealer_profile')) {
         clonedReq = this.preSoldApiKey(clonedReq,userInfo.dealer_profile)
        }})
    }
    //
    // Condition to Invoke the addCurrentDealer method
    //
    if (clonedReq.url.indexOf(this.environment.BASE_SERVICE_URL) > -1) {
      clonedReq = this.addCurrentDealer(clonedReq);
    }
    if (clonedReq.url.includes('/dealer-inventory/vehicles') && !clonedReq.url.includes('/dealer-inventory/vehicles?dealer')) {
      const newParams = new HttpParams().set('includeTempVin', true);
      clonedReq = clonedReq.clone({params: newParams})
    }

    //
    // Authentication header for MST. 
    // This method should come at last. there is overlapping condition between the two
    //
    if (this.Should_Add_Authentication_Token_WithoutBearer(clonedReq.url)) {
      let token: string;

      this._subs.sink = this._store.select(getUserInfo).subscribe(userInfo => {
        if (userInfo?.hasOwnProperty('isIdToken')) {
          if (userInfo.isIdToken.toLowerCase() === 'true'.toLowerCase()) {
            token = sessionStorage.getItem(ViewConstants.ID_TOKEN_HTTP_CLIENT);
          } else if (userInfo.isIdToken.toLowerCase() === 'false'.toLowerCase()) {
            token = sessionStorage.getItem(ViewConstants.ACCESS_TOKEN_HTTP_CLIENT);
          }
        } else {
          token = sessionStorage.getItem(ViewConstants.ACCESS_TOKEN_HTTP_CLIENT);
        }
        clonedReq = clonedReq.clone({ headers: clonedReq.headers.set(ViewConstants.AUTHORIZATION_LOWER_CASE, token) });

        if (userInfo?.hasOwnProperty('profile')) {
          // Condition to Invoke the addProfile method
          if (clonedReq.url.indexOf(this.environment.MST_BASE_SERVICE_URL) > -1) {
            clonedReq = this.addProfile(clonedReq, userInfo.profile);
          }
        }

        if (userInfo?.hasOwnProperty('dealer_profile')) {
          if (clonedReq.url.indexOf(this.environment.BASE_SERVICE_URL) > -1) {
            clonedReq = this.addDealerProfile(clonedReq, userInfo.dealer_profile);
          }
        }

      });
    }
    if (req.urlWithParams.indexOf("offers/currentPagination") > -1) {
      return next.handle(clonedReq).pipe(
        finalize(() => {
          if (!(req.urlWithParams.indexOf("/payments") !== -1 && this.router.url.indexOf(ViewConstants.CUSTOMER_VIEW) !== -1)) {
            this.requestCount--;
          }
          if (this.requestCount === 0 || this.sharedService.getHideLoader()) {
            this.loaderService.hide();
          }
        }),
        catchError((_error: HttpErrorResponse) => {
          return of(new HttpResponse({ body: {}, status: 0 }));
        })
      );
    } else {
      return next.handle(clonedReq).pipe(
        finalize(() => {
          if (!(req.urlWithParams.indexOf("/payments") !== -1 && this.router.url.indexOf(ViewConstants.CUSTOMER_VIEW) !== -1)) {
            this.requestCount--;
          }
          if (this.requestCount === 0 || this.sharedService.getHideLoader()) {
            this.loaderService.hide();
          }
        })
      );
    }
  }

  //
  // Helper method
  //
  private Should_Add_Authentication_Token_WithBearer(url: string): boolean {
    if (url.indexOf('SignInPolicy') > -1)
      {return false;}
    return true;
  }
  private Should_Add_Authentication_Token_WithoutBearer(url: string): boolean {
    if (url.indexOf(ViewConstants.GARAGE) > -1)
      {return true;}
    return false;
  }

  //
  // Intercepting the MST_BASE_SERVICE_URL to add Profile in the header
  //
  private addProfile(url: any, profile: string): any {
    if (url && profile) {
      return url.clone({headers: url.headers.set('x-api-key', profile)});
    } else {
      return url;
    }
  }

  private addIdToken(url: any)
  {
    if (url) {
      return url.clone({headers: url.headers.set('id_token', sessionStorage.getItem(ViewConstants.ACCESS_TOKEN_HTTP_CLIENT))});
    } else {
      return url;
    }
  }

  //
  // Intercepting the BASE_SERVICE_URL to add CurrentDealer in the header
  //
  private addCurrentDealer(url: any): any {
    let dealerCode: any;
    if (this.sharedService?.dealerCode) {
      dealerCode = this.sharedService.dealerCode;
      return url.clone({
        headers: url.headers.set('CurrentDealer', dealerCode)
      });
    } else {
      return url;
    }
  }

  //
  // Intercepting the BASE_SERVICE_URL to add dealerProfile in the header
  //
  private readonly addDealerProfile = (url: any, dealerProfile: string): any => {
    if (url && dealerProfile) {
      return url.clone({headers: url.headers.set('x-api-key', dealerProfile)});
    } else {
      return url;
    }
  }

  private readonly addSignalApiKey = (url: any, signalApiKey: string): any => {
    if (url != null && signalApiKey != null) {
      return url.clone({ headers: url.headers.set('x-api-key', signalApiKey) });
    } else {
      return url;
    }
  }

  private readonly preSoldApiKey = (url: any, preSoldApiKey: string): any => {
    if (url != null && preSoldApiKey != null) {
      let guid = this.sharedFunctionService.createUUID();
      return url.clone({
        headers: url.headers.set('x-api-key', preSoldApiKey).set('X-B3-TraceId', guid)
      });
    } else {
      return url;
    }
  }
}